export default {
  ekyc: {
    title:'スマホのブラウザで下のQRコードを読み取ったうえで、eKyc認証を行ってください',
    btn:'eKycが認証完了状況を確認する',
    tip:'QRで認証が完了したら、eKyc認証完了状況を確認できる。',
    success:'EKYCが完了しました',
    reload:'Ekyc認証を再び取得',
    userInfo: 'ユーザー情報',
    fullName: '姓名',
    address: 'アドレス',
    birthday: '生年月日',
    expireDate: '有効期限',
    images: '写真'
  }
}
